import { logger } from "../helpers/tslog";

export function updateAnchorChildren(
  targetModel: any,
  anchorName: string,
  newModel: any,
  options?: { firstClear?: boolean; limit?: number }
): any[] | void {
  const anchor = targetModel.getByName(anchorName);
  if (!anchor) {
    logger.error(`Anchor '${anchorName}' not found in target model.`);
    return;
  }

  if (options?.firstClear) {
    anchor.children = [];
  }

  const childrenToAdd = options?.limit ? newModel.uiComponents.slice(0, options.limit) : newModel.uiComponents;

  childrenToAdd.forEach((child: any) => {
    anchor.children.push(child);
  });

  return anchor.children;
}

export function deleteAnchorChildren(targetModel: any, anchorName: string, startIndex: number): any[] | void {
  const anchor = targetModel.getByName(anchorName);
  if (!anchor) {
    logger.error(`Anchor '${anchorName}' not found in target model.`);
    return;
  }

  anchor.children.splice(startIndex, anchor.children.length);

  return anchor.children;
}
